export const INITIAL_TIME = 15;
export const ONE_SECOND = 1000; // ms

export const BOARD_SIZE = 360;

// firestore
export const USERS_COLLECTION = 'users';

// field
export const USER_NAME = 'userName';